import { Link } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export const LOGO_SRC =
  "https://static.readdy.ai/image/20debd2956563c6417457fe0fe408adc/7e217269f5a0a1e17604c7a1688b9146.png";

interface BrandLogoProps {
  imgClassName?: string;
  chipClassName?: string;
  className?: string;
  onNavigate?: () => void;
}

export default function BrandLogo({
  imgClassName = "h-10 md:h-12",
  chipClassName = "bg-background-50",
  className = "",
  onNavigate,
}: BrandLogoProps) {
  const { brand } = useSiteSettings();

  return (
    <Link
      to="/"
      onClick={onNavigate}
      aria-label={`${brand.fullName} — home`}
      className={`inline-flex items-center whitespace-nowrap rounded-lg px-2.5 py-1.5 ${chipClassName} ${className}`}
    >
      <img
        src={LOGO_SRC}
        alt={brand.fullName}
        title={`${brand.name} — Agri Tourism`}
        className={`w-auto object-contain ${imgClassName}`}
      />
    </Link>
  );
}